export default __webpack_public_path__ + "static/media/smart-prison-system.bdccb188.jpg";